module.exports = __webpack_public_path__ + "assets/img/28-s.649ad6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/28-s.jpg
// module id = of0P
// module chunks = 0